/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Ref,
  Ref$inboundSchema,
  Ref$Outbound,
  Ref$outboundSchema,
} from "./ref.js";

/**
 * The orientation of the vessel.
 */
export const AnimaticVesselConfigOrientation = {
  Horizontal: "horizontal",
  Vertical: "vertical",
} as const;
/**
 * The orientation of the vessel.
 */
export type AnimaticVesselConfigOrientation = OpenEnum<
  typeof AnimaticVesselConfigOrientation
>;

/**
 * The configuration of the animatic for a vessel.
 */
export type AnimaticVesselConfig = {
  /**
   * A reference to a reading or setting.
   */
  levelRef?: Ref | undefined;
  /**
   * The orientation of the vessel.
   */
  orientation?: AnimaticVesselConfigOrientation | undefined;
};

/** @internal */
export const AnimaticVesselConfigOrientation$inboundSchema: z.ZodType<
  AnimaticVesselConfigOrientation,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(AnimaticVesselConfigOrientation);
/** @internal */
export const AnimaticVesselConfigOrientation$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  AnimaticVesselConfigOrientation
> = openEnums.outboundSchema(AnimaticVesselConfigOrientation);

/** @internal */
export const AnimaticVesselConfig$inboundSchema: z.ZodType<
  AnimaticVesselConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  level_ref: types.optional(Ref$inboundSchema),
  orientation: AnimaticVesselConfigOrientation$inboundSchema.default(
    "vertical",
  ),
}).transform((v) => {
  return remap$(v, {
    "level_ref": "levelRef",
  });
});
/** @internal */
export type AnimaticVesselConfig$Outbound = {
  level_ref?: Ref$Outbound | undefined;
  orientation: string;
};

/** @internal */
export const AnimaticVesselConfig$outboundSchema: z.ZodType<
  AnimaticVesselConfig$Outbound,
  z.ZodTypeDef,
  AnimaticVesselConfig
> = z.object({
  levelRef: Ref$outboundSchema.optional(),
  orientation: AnimaticVesselConfigOrientation$outboundSchema.default(
    "vertical",
  ),
}).transform((v) => {
  return remap$(v, {
    levelRef: "level_ref",
  });
});

export function animaticVesselConfigToJSON(
  animaticVesselConfig: AnimaticVesselConfig,
): string {
  return JSON.stringify(
    AnimaticVesselConfig$outboundSchema.parse(animaticVesselConfig),
  );
}
export function animaticVesselConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticVesselConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticVesselConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticVesselConfig' from JSON`,
  );
}
